var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNoprodIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 14") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mockup-4",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fleet-alert-settings",
    transform: "translate(-949.000000, -194.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(949.000000, 194.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy",
    fill: "#00142D",
    cx: 15,
    cy: 15,
    r: 15
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-608",
    transform: "translate(7.516667, 5.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5833333,5.83333333 L11.25,5.83333333 L11.25,0.416666667 C11.25,0.186666667 11.0633333,0 10.8333333,0 C10.6033333,0 10.4166667,0.186666667 10.4166667,0.416666667 L10.4166667,5.83333333 L4.58333333,5.83333333 L4.58333333,0.416666667 C4.58333333,0.186666667 4.39666667,0 4.16666667,0 C3.93666667,0 3.75,0.186666667 3.75,0.416666667 L3.75,5.83333333 L0.416666667,5.83333333 C0.186666667,5.83333333 0,6.02 0,6.25 C0,6.48 0.186666667,6.66666667 0.416666667,6.66666667 L2.08333333,6.66666667 L2.08333333,12.0833333 C2.08333333,14.01 3.54416667,15.6008333 5.41666667,15.8091667 L5.41666667,17.9166667 C5.41666667,18.1466667 5.60333333,18.3333333 5.83333333,18.3333333 L7.08333333,18.3333333 L7.08333333,19.5833333 C7.08333333,19.8133333 7.27,20 7.5,20 C7.73,20 7.91666667,19.8133333 7.91666667,19.5833333 L7.91666667,18.3333333 L9.16666667,18.3333333 C9.39666667,18.3333333 9.58333333,18.1466667 9.58333333,17.9166667 L9.58333333,15.8091667 C11.455,15.6008333 12.9166667,14.01 12.9166667,12.0833333 L12.9166667,6.66666667 L14.5833333,6.66666667 C14.8133333,6.66666667 15,6.48 15,6.25 C15,6.02 14.8133333,5.83333333 14.5833333,5.83333333",
    id: "Fill-323"
  }))), /*#__PURE__*/React.createElement("line", {
    x1: 4.5,
    y1: 5.5,
    x2: 24.5,
    y2: 25.5,
    id: "Line-7",
    stroke: "#FFFFFF",
    strokeLinecap: "square"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNoprodIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/noprod_icon.3803030121197d82b0378a8881146d93.svg";